<template>
  <div class="lesson-video-player">
    <div
      v-if="simple"
      key="simple"
      class="embed-responsive embed-responsive-16by9"
    >
      <iframe
        class="embed-responsive-item"
        :src="lesson.vimeo_url"
        allowfullscreen
      ></iframe>
    </div>

    <div
      v-else-if="lesson.vimeo_url && lesson.vimeo_url != 'without_link'"
      class="embed-responsive embed-responsive-16by9"
    >
      <iframe
        id="lesson-video-player"
        class="embed-responsive-item"
        :src="lesson.vimeo_url"
        allowfullscreen
      ></iframe>
    </div>

    <video
      v-else
      controls
      playsinline
      crossorigin
      :data-poster="poster"
      id="lesson-video-player"
      key="complex"
    />

    <div v-if="isMobile" class="text-center">
      <button class="btn btn-link btn-sm" @click="simple = true">
        <small>Erro no player? Clique aqui</small>
      </button>
    </div>
  </div>
</template>

<script>
import Hls from "hls.js";
import Plyr from "plyr";
import "plyr/dist/plyr.css";
import get from "lodash/get";
import isMobile from "ismobilejs";

export default {
  props: {
    lesson: {
      type: Object,
      default: () => ({})
    },
    progress: {
      type: Object,
      default: () => ({})
    },
    poster: {}
  },
  data() {
    return {
      player: null,
      simple: false,
      isMobile: isMobile(window.navigator).any
    };
  },
  mounted() {
    if (this.lesson.is_iframe) return;

    const video = document.getElementById("lesson-video-player");

    const isNotMobile = !this.isMobile;

    let controls = [
      "play-large",
      "play",
      "progress",
      "current-time",
      "mute",
      "volume",
      "captions",
      "settings",
      "pip",
      "airplay"
    ];

    if (isNotMobile) {
      controls = ["rewind", "fast-forward", ...controls, "fullscreen"];
    }

    this.player = new Plyr(video, {
      autoplay: false,
      invertTime: false,
      hideControls: false,
      controls,
      i18n: {
        speed: "Velocidade"
      }
    });

    if (video.canPlayType("application/vnd.apple.mpegURL")) {
      let source = document.createElement("source");
      source.src = this.lesson.link;
      source.type = "application/vnd.apple.mpegURL";
      video.appendChild(source);
    } else if (Hls.isSupported()) {
      var config = {
        xhrSetup: function(xhr, url) {
          xhr.withCredentials = false;
        },
        autoStartLoad: false
      };

      const hls = new Hls(config);
      hls.loadSource(this.lesson.link);
      hls.attachMedia(video);

      hls.on(Hls.Events.MANIFEST_PARSED, function() {
        hls.startLoad();
      });
    }

    var firstPlay = true;
    this.player.on("play", () => {
      if (firstPlay) {
        setTimeout(() => {
          this.player.currentTime = get(this.progress, "stopped_at", 0);
        }, 1);
        firstPlay = false;
      }
    });

    const saveCurrentPosition = () => {
      this.saveDuration({
        finished: this.player.currentTime === this.duration,
        duration: this.player.currentTime
      });
    };

    this.interval = setInterval(() => {
      if (this.player.playing) {
        saveCurrentPosition();
      }
    }, 20 * 1000);

    this.player.on("pause", saveCurrentPosition);

    this.player.on("ended", event => {
      setTimeout(() => {
        this.saveDuration({ finished: true, duration: 0 });
      }, 200);
    });
  },
  destroyed() {
    clearInterval(this.interval);
  },
  methods: {
    saveDuration(data) {
      this.$emit("save-progress", data);
    }
  }
};
</script>
